import { useEffect, useRef } from "react";
import { isMobile, scroll2Top } from "../../utils/utils";
import REInfoSignatureDoneBloc from "../../blocs/retirement/info-signature/REInfoSignatureDoneBloc";




export default function REInfoSignatureDonePage() {
    
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

    return (
    
      <div className="entreprise-container">
        <h1 ref={pageGapRef} className="title mb-sm ml-lg-desktop">Documents signés</h1>

        <div ref={pageGapRef} className="page-gap" />
        <div className="flex-grid m-lg-desktop bg-blanc page-content p-lg">
            <REInfoSignatureDoneBloc />
        </div>
      </div>
    
    )

}